// admin-analytics-expansion P3a (D6/D8) — Ticket Detail API client
//
// getTicketDetail(id) → GET /admin/tickets/:id (org_admin | supervisor)
//
// Mirrors the shape of ticket-browse.ts (runtime-validated response via the
// shared Zod schema). Read-only — no mutation methods on this resource.

import type { TicketDetailResponse } from '@jq4race/shared';
import { TicketDetailResponseSchema } from '@jq4race/shared';

import { request } from './client.js';

/**
 * GET /admin/tickets/:id
 *
 * Returns the single-ticket dispute aggregate (full ticket record, photos,
 * incident photos, SMS messages, exits, membership coverage, and payment
 * breakdown incl. delay-recharge settlement). Photo/incident-photo `url`
 * fields are short-TTL presigned GET URLs, not raw storage keys.
 *
 * The audit timeline is NOT part of this response — fetch it separately via
 * getTicketHistory(id) (D7).
 */
export async function getTicketDetail(id: string): Promise<TicketDetailResponse> {
  const payload = await request<unknown>(`/admin/tickets/${encodeURIComponent(id)}`, {
    method: 'GET',
  });
  return TicketDetailResponseSchema.parse(payload);
}
